import {Col, Form, Input, InputNumber, Modal, ModalProps, Row, Space} from "antd";
import {useForm, useWatch} from "antd/lib/form/Form";
import BaseDataSelect from "../../../components/BaseDataSelect";
import * as api from "../../../apis/salesOrder";
import {useRequest} from "ahooks";
import {useEffect} from "react";


interface ModifyShippingCostModalProps extends ModalProps {
    params: any
    onFinish:Function
}

function ModifyShippingCostModal(props: ModifyShippingCostModalProps) {
    const {params = {}, ...otherProps} = props;
    const [form] = useForm();


    useEffect(() => {
        form.setFieldsValue(params);
    }, [params]);

    const {loading: loadingGetShippingCost, run: runGetShippingCost} = useRequest(api.getExpectShippingCost, {
        manual: true,
        onSuccess(res) {
            form.setFieldValue('expectShippingCost', res?.data?.data || 0);
        }
    });

    const handleGetShippingCost = () => {
        const expressId = form.getFieldValue('expressId');
        const orderId = params.orderId;
        runGetShippingCost(orderId, expressId);
    }
    const onOk = (e:any)=>{
        form.validateFields().then(value => {
            props.onFinish?.(value);
        })
    }

    return <Modal {...otherProps} title={'修改运费'} destroyOnClose okButtonProps={{loading: loadingGetShippingCost}} onOk={onOk}>
        <Form form={form}>
            <Form.Item name={'orderId'} noStyle/>
            <Form.Item name={'expressId'} label={'运输方式'}>
                <BaseDataSelect name={'expresses'} style={{flex: 1}} appendNull={false}/>
            </Form.Item>
            <Form.Item name={'expectShippingCost'} label={'计算运费'}>
                <InputNumber step={0.01} style={{width:'100%'}} disabled={true} addonAfter={<a onClick={handleGetShippingCost}>预估运费</a>}/>
            </Form.Item>
            <Form.Item name={'freight'} label={'减免运费'} initialValue={0} rules={[{required: true}]}>
                <InputNumber step={0.01}/>
            </Form.Item>
            <Form.Item name={'remark'} label={'减免说明'}>
                <Input.TextArea rows={3}/>
            </Form.Item>
        </Form>
    </Modal>
}

export default ModifyShippingCostModal;